import React, { useEffect, useState } from 'react'
import axios from 'axios'
import Cookies from 'js-cookie'
import { FaBuilding, FaPlus, FaSyncAlt, FaExclamationCircle, FaUsers, FaEdit, FaTimes, FaSave } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Topbar from '../layouts/Topbar'
import Sidebar from '../layouts/Sidebar'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import './CostCenters.css'
import API_BASE_URL from '../../../config/api'

const CostCenters = () => {
  const [costCenters, setCostCenters] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState('')
  const [editModalOpen, setEditModalOpen] = useState(false)
  const [editCostCenter, setEditCostCenter] = useState(null)
  const [editName, setEditName] = useState('')
  const [editSaving, setEditSaving] = useState(false)
  const baseUrl = API_BASE_URL

  const fetchCostCenters = async () => {
    setLoading(true)
    setError('')
    try {
      const token = Cookies.get('token')
      const response = await axios.get(`${baseUrl}/api/course-centers/`, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setCostCenters(response.data)
    } catch (err) {
      setError('Failed to fetch cost centers.')
      toast.error('Failed to fetch cost centers.')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchCostCenters()
    // eslint-disable-next-line
  }, [])

  const handleEdit = (center) => {
    setEditCostCenter(center)
    setEditName(center.name)
    setEditModalOpen(true)
  }

  const handleEditSave = async (e) => {
    e.preventDefault()
    setEditSaving(true)
    try {
      const token = Cookies.get('token')
      await axios.put(`${baseUrl}/api/course-centers/${editCostCenter.id}/`, {
        name: editName
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      toast.success('Cost Center updated successfully!')
      setEditModalOpen(false)
      setEditCostCenter(null)
      fetchCostCenters()
    } catch (err) {
      toast.error(err.response?.data?.message || 'Failed to update cost center.')
    } finally {
      setEditSaving(false)
    }
  }

  const handleEditClose = () => {
    setEditModalOpen(false)
    setEditCostCenter(null)
  }

  return (
    <>
      <Topbar />
      <Sidebar />
      <div className="cost-centers-container">
        <div className="page-header">
          <div className="header-content">
            <div className="header-left">
              <div className="page-titl">
                <h3 style={{color: '#fff', textAlign: 'left'}}>Cost Centers</h3>
                <p>View and manage all your organization’s cost centers</p>
              </div>
            </div>
            <div className="header-right">
              <Link to="/hr/cost-centers/add" className="add-button">
                <FaPlus />
                <span>Add Cost Center</span>
              </Link>
              <button className="refresh-button" onClick={fetchCostCenters} disabled={loading} title="Refresh">
                <FaSyncAlt className={loading ? 'spin' : ''} />
              </button>
            </div>
          </div>
        </div>

        <div className="cost-centers-content">
          {loading ? (
            <div className="loading-state">
              <FaSyncAlt className="spin" /> Loading cost centers...
            </div>
          ) : error ? (
            <div className="error-state">
              <FaExclamationCircle /> {error}
            </div>
          ) : costCenters.length === 0 ? (
            <div className="empty-state">
              <FaBuilding /> No cost centers found.
            </div>
          ) : (
            <div className="cost-centers-card-grid">
              {costCenters.map((center, idx) => (
                <div className="cost-center-card" key={center.id || idx}>
                 
                  <div className="card-content">
                    <div className="card-title-row">
                      <div className="card-title">{center.name}</div>
                      <button className="action-button edit-button" onClick={() => handleEdit(center)} title="Edit Cost Center">
                        <FaEdit />
                      </button>
                    </div>
                    <div className="card-meta">
                      <span className="card-label">Created:</span> {center.created_at ? new Date(center.created_at).toLocaleDateString() : '-'}
                    </div>
                    <div className="card-meta">
                      <span className="card-label"><FaUsers style={{marginRight: 4}}/> Employees:</span> {center.employee_count !== undefined ? center.employee_count : (center.employees ? center.employees.length : 'N/A')}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Edit Modal */}
      {editModalOpen && (
        <div className="modal-overlay">
          <div className="modal-content">
            <button className="modal-close" onClick={handleEditClose} title="Close">
              <FaTimes />
            </button>
            <h2 className="modal-title">Edit Cost Center</h2>
            <form onSubmit={handleEditSave} className="modal-form">
              <div className="form-group">
                <label htmlFor="editName">
                  <span className="label-text">Cost Center Name</span>
                  <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="editName"
                  value={editName}
                  onChange={e => setEditName(e.target.value)}
                  required
                  className="form-input"
                  disabled={editSaving}
                />
              </div>
              <div className="form-actions">
                <button
                  type="button"
                  className="cancel-button"
                  onClick={handleEditClose}
                  disabled={editSaving}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="submit-button"
                  disabled={editSaving || !editName.trim()}
                >
                  {editSaving ? (
                    <>
                      <FaSave className="spinner" />
                      <span>Saving...</span>
                    </>
                  ) : (
                    <>
                      <FaSave />
                      <span>Save Changes</span>
                    </>
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  )
}

export default CostCenters
